import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export default function useTemasNivel(nivelId, userId) {
  const [useTemas, setuseTemas] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Obtener el token directamente
  const token = localStorage.getItem("token");

  // const fetchTemas = async () => {
  //   if (!nivelId || !userId || !token) {
  //     // console.warn("⚠️ Faltan datos para consultar temas:", { nivelId, userId, token });
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const { data } = await axios.get(
  //       `${API_BASE_URL}/api/temas/info/${nivelId}/${userId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     console.log("✅ Temas cargados correctamente:", data);
  //     setuseTemas(data);
  //   } catch (err) {
  //     console.error("❌ Error al cargar temas:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ✅ Mover esta función afuera para poder reutilizarla
  const obtenerTemas = async () => {
    try {
      const { data } = await axios.get(
        `${API_BASE_URL}/api/temas/info/${nivelId}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setuseTemas(data);
    } catch (error) {
      console.error("❌ Error al obtener temas:", error);
    }
  };

  const crearTema = async (nombre) => {
    try {
      await axios.post(
        "/api/temas",
        { nivelId, nombre },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await obtenerTemas(); // ✅ Recargar temas desde backend
    } catch (err) {
      console.error("❌ Error al crear tema:", err);
    }
  };

  const editarTema = async (id, nombre) => {
    try {
      const { data } = await axios.put(
        `/api/temas/${id}`,
        { nombre },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // ✅ Actualizar en el estado local sin recargar todos
      setuseTemas((prev) => prev.map((t) => (t.id === id ? data : t)));
    } catch (err) {
      console.error("❌ Error al editar tema:", err);
    }
  };

  const eliminarTema = async (id) => {
    try {
      await axios.delete(`/api/temas/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      await obtenerTemas(); // ✅ Recargar temas desde backend
    } catch (err) {
      console.error("❌ Error al eliminar tema:", err);
    }
  };

  useEffect(() => {
    if (!nivelId || !userId || !token) return;
    obtenerTemas();
  }, [nivelId, userId, token]);

  return {
    useTemas,
    loading,
    crearTema,
    editarTema,
    eliminarTema,
    obtenerTemas,
  };
}
